import { CONSTRUCTOR } from '..';
import * as Fragments from './fragments';

// ContactField GraphQL Queries.

// READ read opportunity field GraphQL schema.
export const READ = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getOpportunityFieldSettings',
    args: [],
    argsMap: [],
    fields: '{...OpportunityFieldSettingsResponseFields}',
    fragments: [Fragments.opportunityFieldSettingsResponse],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};

export default READ;
